export var Primo = [
    // 0-16
    { Primo: { '0': 176.93, '300': 157.81, '600': 103.97, '1200': 66.66 } },
    // 17-20
    { Primo: { '0': 188.23, '300': 164.14, '600': 137.34, '1200': 109.48 } },
    // 21
    { Primo: { '0': 293.57, '300': 271.92, '600': 245.02, '1200': 200.02 } },
    // 22
    { Primo: { '0': 300.4, '300': 279.12, '600': 251.84, '1200': 205.74 } },
    // 23
    { Primo: { '0': 307.41, '300': 286.49, '600': 258.72, '1200': 211.52 } },
    // 24
    { Primo: { '0': 314.43, '300': 293.88, '600': 265.57, '1200': 217.27 } },
    // 25
    { Primo: { '0': 321.42, '300': 301.21, '600': 272.29, '1200': 222.97 } },
    // 26
    { Primo: { '0': 328.3, '300': 308.42, '600': 278.9, '1200': 228.59 } },
    // 27
    { Primo: { '0': 335.11, '300': 315.54, '600': 285.43, '1200': 234.17 } },
    // 28
    { Primo: { '0': 341.87, '300': 322.61, '600': 291.89, '1200': 239.72 } },
    // 29
    { Primo: { '0': 348.58, '300': 329.61, '600': 298.3, '1200': 245.22 } },
    // 30
    { Primo: { '0': 355.17, '300': 336.49, '600': 304.62, '1200': 250.63 } },
    // 31
    { Primo: { '0': 361.56, '300': 343.14, '600': 310.72, '1200': 255.87 } },
    // 32
    { Primo: { '0': 367.86, '300': 349.71, '600': 316.76, '1200': 261.05 } },
    // 33
    { Primo: { '0': 374.14, '300': 356.25, '600': 322.79, '1200': 266.22 } },
    // 34
    { Primo: { '0': 380.5, '300': 362.86, '600': 328.88, '1200': 271.45 } },
    // 35
    { Primo: { '0': 387.05, '300': 369.66, '600': 335.15, '1200': 276.83 } },
    // 36
    { Primo: { '0': 393.84, '300': 376.72, '600': 341.65, '1200': 282.44 } },
    // 37
    { Primo: { '0': 400.93, '300': 384.08, '600': 348.4, '1200': 288.29 } },
    // 38
    { Primo: { '0': 408.39, '300': 391.83, '600': 355.5, '1200': 294.47 } },
    // 39
    { Primo: { '0': 416.28, '300': 400.02, '600': 363.02, '1200': 301.02 } },
    // 40
    { Primo: { '0': 424.46, '300': 408.52, '600': 370.78, '1200': 307.84 } },
    // 41
    { Primo: { '0': 432.89, '300': 417.27, '600': 378.79, '1200': 314.88 } },
    // 42
    { Primo: { '0': 441.54, '300': 426.25, '600': 387.04, '1200': 322.16 } },
    // 43
    { Primo: { '0': 450.44, '300': 435.49, '600': 395.54, '1200': 329.67 } },
    // 44
    { Primo: { '0': 459.62, '300': 445.01, '600': 404.36, '1200': 337.45 } },
    // 45
    { Primo: { '0': 468.96, '300': 454.71, '600': 413.37, '1200': 345.47 } },
    // 46
    { Primo: { '0': 478.58, '300': 464.69, '600': 422.7, '1200': 353.81 } },
    // 47
    { Primo: { '0': 488.42, '300': 474.91, '600': 432.32, '1200': 362.44 } },
    // 48
    { Primo: { '0': 498.46, '300': 485.33, '600': 442.2, '1200': 371.34 } },
    // 49
    { Primo: { '0': 508.77, '300': 496.02, '600': 452.4, '1200': 380.53 } },
    // 50
    { Primo: { '0': 519.25, '300': 506.9, '600': 462.82, '1200': 389.96 } },
    // 51
    { Primo: { '0': 530.02, '300': 518.07, '600': 473.55, '1200': 399.69 } },
    // 52
    { Primo: { '0': 541.01, '300': 529.47, '600': 484.53, '1200': 409.67 } },
    // 53
    { Primo: { '0': 552.21, '300': 541.09, '600': 495.76, '1200': 419.89 } },
    // 54
    { Primo: { '0': 563.63, '300': 552.94, '600': 507.21, '1200': 430.36 } },
    // 55
    { Primo: { '0': 575.27, '300': 565.02, '600': 518.93, '1200': 441.06 } },
    // 56
    { Primo: { '0': 587.19, '300': 577.38, '600': 530.98, '1200': 452.08 } },
    // 57
    { Primo: { '0': 599.42, '300': 590.06, '600': 543.35, '1200': 463.42 } },
    // 58
    { Primo: { '0': 611.9, '300': 603, '600': 556.01, '1200': 475.03 } },
    // 59
    { Primo: { '0': 624.73, '300': 616.3, '600': 569.05, '1200': 486.99 } },
    // 60
    { Primo: { '0': 637.85, '300': 629.89, '600': 582.42, '1200': 499.27 } },
    // 61
    { Primo: { '0': 651.23, '300': 643.75, '600': 596.04, '1200': 511.82 } },
    // 62
    { Primo: { '0': 664.85, '300': 657.87, '600': 609.92, '1200': 524.66 } },
    // 63
    { Primo: { '0': 678.72, '300': 672.24, '600': 624.06, '1200': 537.77 } },
    // 64
    { Primo: { '0': 692.92, '300': 686.95, '600': 638.53, '1200': 551.21 } },
    // 65
    { Primo: { '0': 706.29, '300': 700.83, '600': 652.22, '1200': 563.97 } },
    // 66
    { Primo: { '0': 719.82, '300': 714.88, '600': 666.09, '1200': 576.9 } },
    // 67
    { Primo: { '0': 733.24, '300': 728.81, '600': 679.92, '1200': 589.85 } },
    // 68
    { Primo: { '0': 746.55, '300': 742.63, '600': 693.68, '1200': 602.77 } },
    // 69
    { Primo: { '0': 759.68, '300': 756.27, '600': 707.33, '1200': 615.64 } },
    // 70
    { Primo: { '0': 772.6, '300': 769.68, '600': 720.8, '1200': 628.4 } },
];
